import { getCountryDefaultGames, IApplicationState, listCategoriesByTag, listProviders } from '@spinwise/spinwise-core';
import { useDispatch, useSelector } from 'react-redux';

import dynamic from 'next/dynamic';
import { useEffect } from 'react';

const HeaderGuest = dynamic(() => import('../../_brand/navigations/Header/Guest/HeaderGuest'), { ssr: false });
const HeaderUser = dynamic(() => import('../../_brand/navigations/Header/User/HeaderUser'), { ssr: false });

const HeaderManagerComponent = () => {
  const dispatch = useDispatch();

  const authSuccess = useSelector((state: IApplicationState) => state.authReducer.auth?.success);
  const categoriesByTag = useSelector((state: IApplicationState) => state.categoryReducer.categoriesByTag);
  const country_default_games = useSelector((state: IApplicationState) => state.gamesReducer.country_default_games);
  const providers = useSelector((state: IApplicationState) => state.gamesReducer.providers);

  useEffect(() => {
    if (!country_default_games?.length) getCountryDefaultGames()(dispatch);
    if (!categoriesByTag?.loading && !categoriesByTag?.['games']?.length) listCategoriesByTag('games')(dispatch);
    if (!providers?.length) listProviders()(dispatch);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return <>{authSuccess ? <HeaderUser /> : <HeaderGuest />}</>;
};

export default HeaderManagerComponent;
